<ng-container *ngIf="{ isMobile: isMobile$ | async } as obs">
  <div *ngIf="(loading$ | async) === false; else skeleton" class="list">
    <sd-delivery-add-address text="Добавить адрес" *ngIf="!obs.isMobile"></sd-delivery-add-address>
    <sd-delivery-address *ngFor="let address of addressList$ | async" [address]="address"></sd-delivery-address>
  </div>
  <sd-delivery-add-address text="Добавить адрес" *ngIf="obs.isMobile"></sd-delivery-add-address>

  <ng-template #skeleton>
    <div class="list">
      <div class="skelet address"></div>
      <div class="skelet address"></div>
      <div class="skelet address"></div>
    </div>
  </ng-template>
</ng-container>
